import type { ConfigurationContextValue } from "./ConfigurationContext";
// Import the logo as a module asset so Vite resolves its URL relative to the
// JS chunk (import.meta.url), not the current route. A plain "./logos/..." path
// breaks on nested routes and under a deployment sub-path.
import logo from "./logos/sliedrecht-sport-sponsoring.svg";

export const defaultLogo = logo;

export const defaultTitle = "Sliedrecht Sport Sponsoring";

export const defaultSponsoringStages = [
  { value: "suspect", label: "Suspect" },
  { value: "contact", label: "Contact" },
  { value: "info", label: "Info gestuurd" },
  { value: "meeting", label: "Gesprek" },
  { value: "proposal", label: "Voorstel gestuurd" },
  { value: "awaiting", label: "Wacht op reactie" },
  { value: "active", label: "Actief" },
  { value: "ended", label: "Beëindigd" },
  { value: "declined", label: "Afgewezen" },
];

/** Stages that count as a running sponsorship */
export const defaultSponsoringActiveStatuses = ["active"];

/** Stages that are closed (never shown on the board) */
export const defaultSponsoringClosedStatuses = ["ended", "declined"];

export const defaultConfiguration: ConfigurationContextValue = {
  sponsoringStages: defaultSponsoringStages,
  sponsoringActiveStatuses: defaultSponsoringActiveStatuses,
  sponsoringClosedStatuses: defaultSponsoringClosedStatuses,
  title: defaultTitle,
  logo: defaultLogo,
};
